import { createSlice } from "@reduxjs/toolkit";
import { TLanguage } from "../../types/types";
import { languagesApi } from "../api/language.api";


interface LanguagesState {
  languages: TLanguage[];
}

const initialState: LanguagesState = {
  languages: [],

};

const languagesSlice = createSlice({
  name: "languages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      languagesApi.endpoints.getLanguages.matchFulfilled,
      (state, { payload }) => {
        state.languages = payload;
      }
    );
  },
});

export const { actions, reducer } = languagesSlice;
export default languagesSlice.reducer;

